import { render } from "./block_master.vue?vue&type=template&id=596e78ea&scoped=true"
import script from "./block_master.vue?vue&type=script&lang=js"
export * from "./block_master.vue?vue&type=script&lang=js"

import "./block_master.vue?vue&type=style&index=0&id=596e78ea&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596e78ea"]])

export default __exports__